import { useParams } from "react-router-dom";
import { useGetBingoGameQuery } from "bingo/api/bingo-game.api";

export function useBingoGame() {
  const { bingoGameId } = useParams<{ bingoGameId: string }>();
  return useGetBingoGameQuery(bingoGameId!).data;
}
